module.exports = __webpack_public_path__ + "img/crm.8c339064.png";